import { ExportButton } from '@/common/buttons/ExportButton';
import { Grid } from '@/common/grid/Grid';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { DateUtils } from '@/common/utils/DateUtils';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { far } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

export const PerspectiveTrxViewer = () => {

  const { navState } = useNavState();
  const rsrc = useRsrc();
  const module = useModuleFromRoute();

  const gridRef = useRef();

  const [fieldDefs, setFieldDefs] = useState();
  const [exportReq, setExportReq] = useState();

  const pluginCode = navState.pluginCode;

  useEffect(() => {
    rsrc.viewerFieldDefs(module, pluginCode, navState.viewerReqParam, navState.entity).then(fieldDefs => {
      setFieldDefs(fieldDefs);
    });
  }, []);

  const onGridReady = (params) => {
    const dataSource = {
      getRows: (params) => {

        const expr = ExprUtils.filterModelToExpr(params.filterModel, fieldDefs);

        const reqParam = {
          ...navState.viewerReqParam,
          startRow: params.startRow,
          endRow: params.endRow,
          expr
        };

        buildAndSetExportReq(reqParam, pluginCode);

        rsrc.viewerRows(module, pluginCode, reqParam, navState.entity).then(res => {
          gridRef.current.onGridSuccess(res, params);
          gridRef.current.resize();
        })

        rsrc.viewerCount(module, pluginCode, reqParam, navState.entity).then(count => {
          gridRef.current.setCount(count);
        })

        rsrc.viewerAggTotals(module, pluginCode, reqParam, navState.entity).then(aggTotals => {
          gridRef.current.setTotalsRow(aggTotals);
        })
      }
    }

    gridRef.current.setDataSource(dataSource);
  }

  const buildAndSetExportReq = (reqParam, plugin) => {
    const exportReq = {
      timeZoneName: DateUtils.timeZoneName(),
      name: navState.title + ' Export',
      module,
      entity: navState.entity,
      uiType: 'VIEWER',
      viewerPluginCode: plugin,
      viewerReqParam: reqParam,
      fieldDefs,
    };

    setExportReq(exportReq);
  }

  return (
    fieldDefs &&
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%'
        }}
      >
        <Title icon={far.faListUl} title={navState.title} />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} >
          <ExportButton exportReq={exportReq} />
        </Box>
      </Box>
      <Grid
        ref={gridRef}
        gridOptions={{ fieldDefs }}
        events={{ onGridReady }}
      />
    </>
  );
}